<ms-organization-profile-header 
  [(organization)]="organization" 
  [(organizationSettings)]="organizationSettings"
  [isLoading]="isLoading()" 
  [navItems]="filteredNavItems()" 
  (tabChanged)="onTabChanged($event)"
  (organizationUpdated)="onOrganizationUpdated()">
</ms-organization-profile-header>

<div class="tab-content mx-0 mx-sm-4" id="profileTabsContent">
  @if (organization()) {
  @for (item of filteredNavItems(); track item.id; let i = $index) {
    @if (item.active) {
      <div class="tab-pane fade" 
           [class.show]="item.active" 
           [class.active]="item.active" 
           [id]="item.id" 
           role="tabpanel"
           [attr.aria-labelledby]="item.id + '-tab'" 
           tabindex="0">

        @switch (item.id) {

          @case (OrganizationProfileNavItems.Overview) {
            <ms-organization-overview [organization]="organization()" [organizationSettings]="organizationSettings()" [isLoading]="isLoading()"></ms-organization-overview>
          }

          @case (OrganizationProfileNavItems.Settings) {
            <ms-organization-settings [organization]="organization()" [organizationSettings]="organizationSettings()" (reloadOrganization)="onStripeOnboardingComplete()" (organizationSettingsUpdated)="onOrganizationSettingsUpdated($event)" (organizationUpdated)="onOrganizationModelUpdated($event)"> </ms-organization-settings>
          }

          @case (OrganizationProfileNavItems.Contacts) {
            <ms-organization-contacts *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Update] }" [organization]="organization()" (organizationUpdated)="onOrganizationModelUpdated($event)"> </ms-organization-contacts>
          }

          @case (OrganizationProfileNavItems.Addresses) {
            <ms-organization-addresses *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Update] }" [organization]="organization()" (organizationUpdated)="onOrganizationModelUpdated($event)"> </ms-organization-addresses>
          }

          @case (OrganizationProfileNavItems.ActivityLogs) {
            <ms-organization-logs [organization]="organization()"> </ms-organization-logs>
          }

          @default {
            <div class="card">
              <div class="card-body">
                <p>Content for {{item.label}} will be implemented here.</p>
              </div>
            </div>
          }
        }
      </div>
    }
  }
  }
</div>
